<template>
  <tr class="border border-start-0 border-end-0 align-top">
    <td class="col-6 border-right">
      <Select2
          :parent-id="parentId ? `#${parentId}` : ''"
          container-class="col-12"
          :multiple="false"
          :show-search="true"
          :selectClass="'form-select form-control-lg form-select-solid'"
          :name="`project-collaborators-${index}`"
          :isRequired="true"
          :placeholderText="$t('projects.placeholder.customer')"
          v-model="contactData.contact_id"
          :IsInputGroup="true" 
          icon="bi bi-plus"
          :clickAddon="() => openContactModal(index)"
          >
        <option v-for="(contact, index) in filterContacts()" :key="index" :value="contact.id">
          {{ contact.fullname }}
        </option>
      </Select2>
    </td>
    <td class="col-5 border-right">
      <Select2
          container-class="col-12"
          :multiple="false"
          :show-search="true"
          selectClass="form-control form-select form-select-solid rounded-end-0 border-start"
          :name="`project-customer-${index}-status`"
          v-model="contactData.contact_status_id"
          :placeholderText="$t('projects.placeholder.customerStatus')"
          :IsInputGroup="true"
          :is-required="true"
          icon="bi bi-plus"
          :parent-id="parentId ? `#${parentId}` : ''"
          :clickAddon="() => openCustomerStatusModal(index)">
        <option v-for="(stat, index) in status" :key="index" :value="stat.id">
          {{ stat.name }}
        </option>
      </Select2>
    </td>
    <td class="text-center" style="vertical-align: middle">
      <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="deleteRow(index)">
        <i class="bi bi-trash-fill fs-5"></i>
      </a>
    </td>
  </tr>



</template>
 
<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, ref} from "vue";
import {useStore} from "vuex";

const store = useStore()
const emits = defineEmits(["deleteContact"])
const props = defineProps({
  contact: {
    type: Object,
    default: () => ({
      contact_id: '',
      contact_status_id: '',
    })
  },
  id:{
    type: String, 
    default: "create_project_modal"
  },
  index: Number,
  parentId: String,
  selectedContacts: Array,
  openCustomerStatusModal: Function,
  openContactModal: Function,
})

const contactData = ref(props.contact)

const contacts = computed(() => store.getters['contacts/getContacts'])
const status = computed(() => store.getters['customerStatus/getCustomerStatus'])

function filterContacts() {
  const current = contactData.value.contact_id
  const idsWithoutCur = props.selectedContacts.filter(id => id !== current)
  return contacts.value.filter(contact => !idsWithoutCur?.includes(contact.id) );
}

function deleteRow(index) {
  emits('deleteContact', index)
}


</script>